
const uitvraag = {

	init() {

		// Stap activetab
		var stap = document.querySelector('div.step-tabs ul.nav.nav-tabs').getAttribute('data-tab-active');
		document.querySelector('.nav-tabs-active-' + stap + ' .nav-link').classList.add('active');

		// Disable submit button
		$('button[type=button].btn-submit').attr('disabled', 'true');

		// Controleer of alle checkboxes zijn aangevinkt
		$('form.form-uitvraag input[type=checkbox]').on('change', function() {
			uitvraag.checkSubmitAllowed();
		});

		// Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
		$('#modalBevestigen').on('click', '.btn-submit-confirm', function() {
			uitvraag.submitForm();
		});

	},

	// Function om te controleren of alle checkboxes zijn aangevinkt en enable button
	checkSubmitAllowed: function() {
		var button = $('form.form-uitvraag button[type=button]');
		button.removeAttr('disabled');
		$('form.form-uitvraag input[type=checkbox]').each(function() {
			if (!$(this).is(':checked')) {
				button.attr('disabled', true);
			}
		});
	},

	// Functie die de ingevoerde gegevens in het formulier submit
	submitForm: function() {
		$('#modalBevestigen').modal('hide');
		setTimeout(function() {
			$('form[data-validate]')[0].submit();
		}, 200);
	}

};

export default uitvraag;
